export const AQpoToolbarConfig = [
    {
        id: "newPO",
        titleText: "New Acquisition Supplier PO",
        textWithIcon: true,
        isIcon: true,
        iconClass: "fluent:document-add-28-regular",
        buttonTypeClassName: "default-btn border-right",
        actionName: "NEW",

    },
    {
        id: "savePO",
        titleText: "Save Acquisition Supplier PO",
        textWithIcon: true,
        isIcon: true,
        iconClass: "ion:save-outline",
        buttonTypeClassName: "default-btn border-right",
        actionName: "SAVE"
    },
    {
        id: "printPO",
        titleText: "Print Acquisition Supplier PO",
        textWithIcon: true,
        isIcon: true,
        iconClass: "cil:print",
        buttonTypeClassName: "default-btn",
        actionName: "PRINT"
    },
];


export const AQpoToolbarDeleteBtnConfig = [
    {
        id: "deletePo",
        titleText: "Delete Acquisition Supplier PO",
        textWithIcon: true,
        isIcon: true,
        iconClass: "fluent:delete-24-regular",
        buttonTypeClassName: "default-btn",
        actionName: "DELETE"
    },
]